import { render, staticRenderFns } from "./registerTrip.vue?vue&type=template&id=323a2708&"
import script from "./registerTrip.vue?vue&type=script&lang=js&"
export * from "./registerTrip.vue?vue&type=script&lang=js&"
import style0 from "./registerTrip.vue?vue&type=style&index=0&id=323a2708&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports